import { render } from "./ChangeCategoryDialog.vue?vue&type=template&id=9c401ba2&scoped=true"
import script from "./ChangeCategoryDialog.vue?vue&type=script&lang=js"
export * from "./ChangeCategoryDialog.vue?vue&type=script&lang=js"

import "./ChangeCategoryDialog.vue?vue&type=style&index=0&id=9c401ba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c401ba2"]])

export default __exports__